export const SEARCH_UNSPLASH_REQUEST = "SEARCH_UNSPLASH_REQUEST";
export const SEARCH_UNSPLASH_SUCCESS = "SEARCH_UNSPLASH_SUCCESS";
export const SEARCH_UNSPLASH_FAIL = "SEARCH_UNSPLASH_FAIL";
